import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import './assets/shared.css'

import axios from 'axios'

Vue.config.productionTip = false
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
//axios.defaults.headers.common['Access-Control-Allow-Headers'] = 'Content-Type, Authorization';
axios.defaults.headers.common['Access-Control-Allow-Credentials'] = 'true';
// URL de la API — se configura por entorno en .env.production / .env.development
axios.defaults.baseURL = process.env.VUE_APP_API_URL
// Producción (npm run build) → http://localhost:8080/  (.env.production)
// Desarrollo  (npm run serve) → https://localhost:5001  (.env.development)

new Vue({
  router,
  store,
  vuetify,
  axios,
  render: function (h) { return h(App) }
}).$mount('#app')
